import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, ChevronDown, Calendar as CalendarIcon, Filter, ArrowDownCircle, ArrowUpCircle, Sparkles, Clock, AlertTriangle, Plus, CheckCircle, Search } from 'lucide-react';
import { NewEsigenzaModal } from './modals/NewEsigenzaModal';
// --- Types ---
type EventType = 'check-in' | 'check-out' | 'intervention' | 'esigenza' | 'gap';
interface CalendarEvent {
  id: number;
  type: EventType;
  title: string;
  propertyId: number;
  propertyName: string;
  date: string; // YYYY-MM-DD
  startTime: string; // HH:MM
  endTime: string; // HH:MM
  fornitore?: string;
  isUrgent?: boolean;
  status?: 'scheduled' | 'pending' | 'completed';
}
interface Property {
  id: number;
  name: string;
  color: string;
}
// --- Mock Data ---
const properties: Property[] = [{
  id: 1,
  name: 'Appartamento Prati',
  color: 'blue'
}, {
  id: 2,
  name: 'Loft Centro Storico',
  color: 'purple'
}, {
  id: 3,
  name: 'Bilocale Trastevere',
  color: 'green'
}, {
  id: 4,
  name: 'Suite Testaccio',
  color: 'orange'
}];
// Properties with addresses for the NewEsigenzaModal
const propertiesForModal = [{
  id: 1,
  name: 'Appartamento Prati',
  address: 'Via Cola di Rienzo 28'
}, {
  id: 2,
  name: 'Loft Centro Storico',
  address: 'Via del Corso 150'
}, {
  id: 3,
  name: 'Bilocale Trastevere',
  address: 'Via della Lungaretta 12'
}, {
  id: 4,
  name: 'Suite Testaccio',
  address: 'Via Marmorata 32'
}];
const mockEvents: CalendarEvent[] = [
// Monday 9 Feb
{
  id: 1,
  type: 'check-out',
  title: 'Check-out',
  propertyId: 2,
  propertyName: 'Loft Centro Storico',
  date: '2026-02-09',
  startTime: '10:00',
  endTime: '10:30'
}, {
  id: 2,
  type: 'intervention',
  title: 'Pulizia Standard',
  propertyId: 2,
  propertyName: 'Loft Centro Storico',
  date: '2026-02-09',
  startTime: '10:00',
  endTime: '12:30',
  fornitore: 'Marco R.',
  status: 'scheduled'
}, {
  id: 3,
  type: 'check-in',
  title: 'Check-in',
  propertyId: 2,
  propertyName: 'Loft Centro Storico',
  date: '2026-02-09',
  startTime: '15:00',
  endTime: '15:30'
},
// Tuesday 10 Feb
{
  id: 4,
  type: 'check-out',
  title: 'Check-out',
  propertyId: 1,
  propertyName: 'Appartamento Prati',
  date: '2026-02-10',
  startTime: '10:00',
  endTime: '10:30'
}, {
  id: 5,
  type: 'gap',
  title: 'Slot scoperto',
  propertyId: 1,
  propertyName: 'Appartamento Prati',
  date: '2026-02-10',
  startTime: '10:00',
  endTime: '12:00',
  isUrgent: true
}, {
  id: 6,
  type: 'check-in',
  title: 'Check-in',
  propertyId: 1,
  propertyName: 'Appartamento Prati',
  date: '2026-02-10',
  startTime: '15:00',
  endTime: '15:30'
},
// Wednesday 11 Feb
{
  id: 7,
  type: 'intervention',
  title: 'Pulizia ordinaria',
  propertyId: 4,
  propertyName: 'Suite Testaccio',
  date: '2026-02-11',
  startTime: '09:00',
  endTime: '11:15',
  fornitore: 'Lucia M.',
  status: 'scheduled'
}, {
  id: 8,
  type: 'check-out',
  title: 'Check-out',
  propertyId: 4,
  propertyName: 'Suite Testaccio',
  date: '2026-02-11',
  startTime: '11:00',
  endTime: '11:30'
}, {
  id: 9,
  type: 'esigenza',
  title: 'Sanificazione post-infestazione',
  propertyId: 4,
  propertyName: 'Suite Testaccio',
  date: '2026-02-11',
  startTime: '14:00',
  endTime: '16:00',
  status: 'pending',
  isUrgent: true
},
// Thursday 12 Feb
{
  id: 10,
  type: 'check-out',
  title: 'Check-out',
  propertyId: 3,
  propertyName: 'Bilocale Trastevere',
  date: '2026-02-12',
  startTime: '10:00',
  endTime: '10:30'
}, {
  id: 11,
  type: 'gap',
  title: 'Slot scoperto',
  propertyId: 3,
  propertyName: 'Bilocale Trastevere',
  date: '2026-02-12',
  startTime: '10:00',
  endTime: '14:00',
  isUrgent: true
},
// Friday 13 Feb
{
  id: 12,
  type: 'intervention',
  title: 'Pulizia ordinaria programmata',
  propertyId: 2,
  propertyName: 'Loft Centro Storico',
  date: '2026-02-13',
  startTime: '10:00',
  endTime: '12:30',
  fornitore: 'Marco R.',
  status: 'scheduled'
}, {
  id: 13,
  type: 'check-in',
  title: 'Check-in',
  propertyId: 1,
  propertyName: 'Appartamento Prati',
  date: '2026-02-13',
  startTime: '15:00',
  endTime: '15:30'
}, {
  id: 14,
  type: 'check-in',
  title: 'Check-in',
  propertyId: 2,
  propertyName: 'Loft Centro Storico',
  date: '2026-02-13',
  startTime: '16:00',
  endTime: '16:30'
},
// Sunday 15 Feb
{
  id: 15,
  type: 'check-out',
  title: 'Check-out',
  propertyId: 1,
  propertyName: 'Appartamento Prati',
  date: '2026-02-15',
  startTime: '10:00',
  endTime: '10:30'
}];
// --- Helper Functions ---
const getEventColorStyles = (type: EventType) => {
  switch (type) {
    case 'check-in':
      return 'bg-green-50 border border-green-200 text-green-800';
    case 'check-out':
      return 'bg-amber-50 border border-amber-200 text-amber-800';
    case 'intervention':
      return 'bg-blue-50 border border-blue-200 text-blue-800';
    case 'esigenza':
      return 'bg-amber-50 border-2 border-dashed border-amber-400 text-amber-800 animate-pulse';
    case 'gap':
      return 'bg-red-50 border-2 border-dashed border-red-400 text-red-800';
    default:
      return 'bg-gray-50 border border-gray-200 text-gray-800';
  }
};
const getEventIcon = (type: EventType) => {
  switch (type) {
    case 'check-in':
      return <ArrowDownCircle size={14} data-id="element-352" />;
    case 'check-out':
      return <ArrowUpCircle size={14} data-id="element-353" />;
    case 'intervention':
      return <Sparkles size={14} data-id="element-354" />;
    case 'esigenza':
      return <Clock size={14} data-id="element-355" />;
    case 'gap':
      return <AlertTriangle size={14} data-id="element-356" />;
  }
};
const timeToMinutes = (time: string) => {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
};
const getEventPosition = (startTime: string, endTime: string) => {
  const startMinutes = timeToMinutes(startTime);
  const endMinutes = timeToMinutes(endTime);
  const dayStartMinutes = 8 * 60; // 08:00 start
  // 60px per hour
  const top = (startMinutes - dayStartMinutes) / 60 * 60;
  const height = (endMinutes - startMinutes) / 60 * 60;
  return {
    top,
    height: Math.max(height, 30)
  }; // Min height 30px
};
export function HostCalendarioPage() {
  const [viewMode, setViewMode] = useState<'week' | 'day'>('week');
  const [selectedPropertyId, setSelectedPropertyId] = useState<number | 'all'>('all');
  const [activeFilters, setActiveFilters] = useState<Set<EventType>>(new Set(['check-in', 'check-out', 'intervention', 'esigenza', 'gap']));
  const [showUrgentOnly, setShowUrgentOnly] = useState(false);
  const [showNewEsigenzaModal, setShowNewEsigenzaModal] = useState(false);
  const [preSelectedPropertyId, setPreSelectedPropertyId] = useState<number | null>(null);
  // Today's date and current time
  const today = '2026-02-09';
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const currentTimeInMinutes = currentHour * 60 + currentMinute;
  // Fixed date for demo: 9-15 Feb 2026
  const weekDays = [{
    date: '2026-02-09',
    day: 'Lun',
    label: '9'
  }, {
    date: '2026-02-10',
    day: 'Mar',
    label: '10'
  }, {
    date: '2026-02-11',
    day: 'Mer',
    label: '11'
  }, {
    date: '2026-02-12',
    day: 'Gio',
    label: '12'
  }, {
    date: '2026-02-13',
    day: 'Ven',
    label: '13'
  }, {
    date: '2026-02-14',
    day: 'Sab',
    label: '14'
  }, {
    date: '2026-02-15',
    day: 'Dom',
    label: '15'
  }];
  const hours = Array.from({
    length: 13
  }, (_, i) => i + 8); // 08:00 to 20:00
  const toggleFilter = (type: EventType) => {
    const newFilters = new Set(activeFilters);
    if (newFilters.has(type)) {
      newFilters.delete(type);
    } else {
      newFilters.add(type);
    }
    setActiveFilters(newFilters);
  };
  const handleCreateEsigenza = (esigenza: any) => {
    console.log('Nuova esigenza creata:', esigenza);
    alert('Esigenza creata con successo!');
    setShowNewEsigenzaModal(false);
    setPreSelectedPropertyId(null);
  };
  const handleOpenNewEsigenza = (propertyId?: number) => {
    setPreSelectedPropertyId(propertyId ?? null);
    setShowNewEsigenzaModal(true);
  };
  const filteredEvents = mockEvents.filter(event => {
    if (selectedPropertyId !== 'all' && event.propertyId !== selectedPropertyId) return false;
    if (!activeFilters.has(event.type)) return false;
    if (showUrgentOnly && !event.isUrgent) return false;
    return true;
  });
  const getEventsForDay = (date: string) => {
    return filteredEvents.filter(e => e.date === date);
  };
  // Find today's column index for the red indicator
  const todayColumnIndex = weekDays.findIndex(d => d.date === today);
  const dayStartMinutes = 8 * 60;
  const currentTimeTop = (currentTimeInMinutes - dayStartMinutes) / 60 * 60;
  const showCurrentTimeIndicator = todayColumnIndex >= 0 && currentHour >= 8 && currentHour <= 20;
  return <div className="animate-in fade-in slide-in-from-bottom-4 duration-500 space-y-6 h-[calc(100vh-100px)] flex flex-col" data-id="element-357">
      {/* Header Section */}
      <div className="flex flex-col gap-6 flex-shrink-0" data-id="element-358">
        <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4" data-id="element-359">
          <div data-id="element-360">
            <h1 className="text-xl lg:text-2xl font-bold font-montserrat text-navy mb-1" data-id="element-361">
              Calendario
            </h1>
            <p className="text-sm text-gray-500" data-id="element-362">
              Visualizza tutti gli eventi e gli slot delle tue proprietà
            </p>
          </div>

          <div className="flex items-center gap-4" data-id="element-363">
            <button onClick={() => handleOpenNewEsigenza()} className="flex items-center gap-2 bg-teal-deep text-white rounded-lg hover:bg-teal-deep/90 font-medium text-sm px-4 py-2.5 transition-colors shadow-sm whitespace-nowrap min-h-[44px]" data-id="element-364">
              <Plus size={18} data-id="element-365" />
              <span data-id="element-366">Crea Esigenza</span>
            </button>

            <div className="flex items-center bg-white border border-gray-200 rounded-lg p-1 shadow-sm" data-id="element-367">
              <button className="p-1 hover:bg-gray-100 rounded-md transition-colors text-gray-500" data-id="element-368">
                <ChevronLeft size={20} data-id="element-369" />
              </button>
              <span className="px-4 text-sm font-medium text-navy min-w-[140px] text-center" data-id="element-370">
                9 - 15 Feb 2026
              </span>
              <button className="p-1 hover:bg-gray-100 rounded-md transition-colors text-gray-500" data-id="element-371">
                <ChevronRight size={20} data-id="element-372" />
              </button>
            </div>

            <div className="bg-gray-100 p-1 rounded-lg flex" data-id="element-373">
              <button onClick={() => setViewMode('week')} className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all ${viewMode === 'week' ? 'bg-white text-navy shadow-sm' : 'text-gray-500 hover:text-navy'}`} data-id="element-374">
                Settimana
              </button>
              <button onClick={() => setViewMode('day')} className={`px-4 py-1.5 rounded-md text-sm font-medium transition-all ${viewMode === 'day' ? 'bg-white text-navy shadow-sm' : 'text-gray-500 hover:text-navy'}`} data-id="element-375">
                Giorno
              </button>
            </div>
          </div>
        </div>

        {/* Filters Bar */}
        <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between border-b border-gray-200 pb-4" data-id="element-376">
          <div className="flex flex-wrap items-center gap-3" data-id="element-377">
            {/* Property Selector */}
            <div className="relative" data-id="element-378">
              <select value={selectedPropertyId} onChange={e => setSelectedPropertyId(e.target.value === 'all' ? 'all' : Number(e.target.value))} className="appearance-none bg-white border border-gray-200 rounded-lg pl-4 pr-10 py-2 text-sm text-navy font-medium focus:ring-2 focus:ring-teal-deep focus:border-transparent outline-none cursor-pointer min-w-[200px]" data-id="element-379">
                <option value="all" data-id="element-380">Tutte le Proprietà</option>
                {properties.map(p => <option key={p.id} value={p.id} data-id="element-381">
                    {p.name}
                  </option>)}
              </select>
              <ChevronDown size={16} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-382" />
              {selectedPropertyId !== 'all' && <div className="absolute left-2 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-blue-500" data-id="element-383"></div>}
            </div>

            <div className="h-8 w-px bg-gray-200 mx-1 hidden lg:block" data-id="element-384"></div>

            {/* Event Type Chips */}
            <div className="flex flex-wrap gap-2" data-id="element-385">
              <button onClick={() => toggleFilter('check-in')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${activeFilters.has('check-in') ? 'bg-green-50 text-green-700 border-green-200' : 'bg-gray-50 text-gray-400 border-gray-200 opacity-60'}`} data-id="element-386">
                <ArrowDownCircle size={14} data-id="element-387" />
                Check-in
              </button>
              <button onClick={() => toggleFilter('check-out')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${activeFilters.has('check-out') ? 'bg-amber-50 text-amber-700 border-amber-200' : 'bg-gray-50 text-gray-400 border-gray-200 opacity-60'}`} data-id="element-388">
                <ArrowUpCircle size={14} data-id="element-389" />
                Check-out
              </button>
              <button onClick={() => toggleFilter('intervention')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${activeFilters.has('intervention') ? 'bg-blue-50 text-blue-700 border-blue-200' : 'bg-gray-50 text-gray-400 border-gray-200 opacity-60'}`} data-id="element-390">
                <Sparkles size={14} data-id="element-391" />
                Interventi
              </button>
              <button onClick={() => toggleFilter('esigenza')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${activeFilters.has('esigenza') ? 'bg-amber-50 text-amber-700 border-amber-200' : 'bg-gray-50 text-gray-400 border-gray-200 opacity-60'}`} data-id="element-392">
                <Clock size={14} data-id="element-393" />
                In attesa
              </button>
              <button onClick={() => toggleFilter('gap')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border border-dashed transition-all ${activeFilters.has('gap') ? 'bg-red-50 text-red-700 border-red-300' : 'bg-gray-50 text-gray-400 border-gray-200 opacity-60'}`} data-id="element-394">
                <AlertTriangle size={14} data-id="element-395" />
                Slot scoperti
              </button>
            </div>
          </div>

          {/* Urgent Toggle */}
          <div className="flex items-center gap-2" data-id="element-396">
            <span className="text-sm text-gray-600 font-medium" data-id="element-397">
              Solo urgenti
            </span>
            <button onClick={() => setShowUrgentOnly(!showUrgentOnly)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${showUrgentOnly ? 'bg-teal-deep' : 'bg-gray-200'}`} data-id="element-398">
              <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${showUrgentOnly ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-399" />
            </button>
          </div>
        </div>

        {/* Legend */}
        <div className="flex flex-wrap gap-4 text-[10px] sm:text-xs text-gray-500" data-id="element-400">
          <div className="flex items-center gap-1.5" data-id="element-401">
            <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-402"></div>
            <span data-id="element-403">Check-in</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-404">
            <div className="w-2 h-2 rounded-full bg-amber-500" data-id="element-405"></div>
            <span data-id="element-406">Check-out</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-407">
            <div className="w-2 h-2 rounded-full bg-blue-500" data-id="element-408"></div>
            <span data-id="element-409">Intervento programmato</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-410">
            <div className="w-2 h-2 rounded-full bg-amber-400 border border-dashed border-amber-600" data-id="element-411"></div>
            <span data-id="element-412">Esigenza in attesa</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-413">
            <div className="w-2 h-2 rounded-full bg-red-500 border border-dashed border-red-700" data-id="element-414"></div>
            <span data-id="element-415">Slot scoperto</span>
          </div>
        </div>
      </div>

      {/* Calendar Grid */}
      <div className="flex-1 overflow-y-auto bg-white border border-gray-200 rounded-xl shadow-sm relative flex flex-col min-h-[600px]" data-id="element-416">
        {/* Header Row */}
        <div className="flex border-b border-gray-200 sticky top-0 bg-white z-20" data-id="element-417">
          <div className="w-16 flex-shrink-0 border-r border-gray-100 bg-gray-50/50" data-id="element-418"></div>{' '}
          {/* Time column header */}
          {weekDays.map((day, index) => {
          const isToday = day.date === today;
          const dayEvents = getEventsForDay(day.date);
          return <div key={day.date} className={`flex-1 min-w-[120px] py-3 px-2 text-center border-r border-gray-100 last:border-r-0 ${isToday ? 'bg-blue-50/30' : ''}`} data-id="element-419">
                <div className={`text-xs uppercase font-semibold mb-1 ${isToday ? 'text-teal-deep' : 'text-gray-500'}`} data-id="element-420">
                  {day.day}
                </div>
                <div className={`text-lg font-bold font-montserrat flex items-center justify-center gap-1.5 ${isToday ? 'text-teal-deep' : 'text-navy'}`} data-id="element-421">
                  {day.label}
                  {dayEvents.length > 0 && <span className="flex h-5 w-5 items-center justify-center rounded-full bg-gray-100 text-[10px] font-bold text-gray-600" data-id="element-422">
                      {dayEvents.length}
                    </span>}
                </div>
              </div>;
        })}
        </div>

        {/* Grid Body */}
        <div className="flex flex-1 relative" data-id="element-423">
          {/* Time Column */}
          <div className="w-16 flex-shrink-0 border-r border-gray-100 bg-gray-50/30 text-xs text-gray-400 font-medium relative z-10" data-id="element-424">
            {hours.map(hour => <div key={hour} className="h-[60px] border-b border-gray-100 relative" data-id="element-425">
                <span className="absolute -top-2.5 right-2 bg-white px-1" data-id="element-426">
                  {hour.toString().padStart(2, '0')}:00
                </span>
              </div>)}
          </div>

          {/* Days Columns */}
          {weekDays.map(day => {
          const isToday = day.date === today;
          const dayEvents = getEventsForDay(day.date);
          return <div key={day.date} className={`flex-1 min-w-[120px] relative border-r border-gray-100 last:border-r-0 ${isToday ? 'bg-blue-50/10' : ''}`} data-id="element-427">
                {/* Hour Guidelines */}
                {hours.map(hour => <div key={hour} className="h-[60px] border-b border-gray-50" data-id="element-428"></div>)}

                {/* Events */}
                {dayEvents.map(event => {
              const {
                top,
                height
              } = getEventPosition(event.startTime, event.endTime);
              const styleClass = getEventColorStyles(event.type);
              return <div key={event.id} className={`absolute left-1 right-1 rounded-md p-2 text-xs shadow-sm overflow-hidden hover:shadow-md transition-all cursor-pointer z-10 group ${styleClass}`} style={{
                top: `${top}px`,
                height: `${height}px`
              }} data-id="element-429">
                      <div className="flex items-start gap-1.5 mb-0.5" data-id="element-430">
                        <span className="mt-0.5 opacity-70" data-id="element-431">
                          {getEventIcon(event.type)}
                        </span>
                        <span className="font-bold truncate leading-tight" data-id="element-432">
                          {event.title}
                        </span>
                      </div>

                      {event.type === 'intervention' && <div className="text-[10px] opacity-80 mb-0.5" data-id="element-433">
                          {event.startTime} - {event.endTime}
                        </div>}

                      <div className="text-[10px] font-medium truncate opacity-90" data-id="element-434">
                        {event.propertyName}
                      </div>

                      {event.fornitore && <div className="text-[9px] mt-1 opacity-70 truncate" data-id="element-435">
                          Fornitore: {event.fornitore}
                        </div>}

                      {event.type === 'gap' && <button onClick={e => {
                  e.stopPropagation();
                  handleOpenNewEsigenza(event.propertyId);
                }} className="mt-2 w-full flex items-center justify-center gap-1 bg-white/80 hover:bg-white text-teal-deep text-[10px] font-bold py-1 rounded shadow-sm transition-colors" data-id="element-436">
                          <Plus size={10} data-id="element-437" /> Crea Esigenza
                        </button>}
                    </div>;
            })}
              </div>;
        })}

          {/* Current Time Indicator - positioned on today's column */}
          {showCurrentTimeIndicator && <div className="absolute z-30 pointer-events-none flex items-center" style={{
          top: `${currentTimeTop}px`,
          left: `${64 + todayColumnIndex * (100 / 7)}%`,
          right: `${100 / 7 * (6 - todayColumnIndex)}%`
        }} data-id="element-438">
              <div className="w-2.5 h-2.5 rounded-full bg-red-500 -ml-1 shadow-sm" data-id="element-439"></div>
              <div className="flex-1 border-t-2 border-red-500" data-id="element-440"></div>
            </div>}
        </div>
      </div>
      {/* NewEsigenzaModal */}
      <NewEsigenzaModal isOpen={showNewEsigenzaModal} onClose={() => {
      setShowNewEsigenzaModal(false);
      setPreSelectedPropertyId(null);
    }} onSave={handleCreateEsigenza} properties={propertiesForModal} preSelectedPropertyId={preSelectedPropertyId} data-id="element-441" />
    </div>;
}